import { Route, Routes } from "react-router-dom";

import Main from "./components/Main";
import NotFound from "./components/NotFound";
import PrivateRoute from "./components/PrivateRoute";

const App = () => {
    return (
        <Routes>
            <Route path="/" exact element={<PrivateRoute />}>
                <Route path="/" exact element={<Main />} />
            </Route>
            <Route path="/home" exact element={<PrivateRoute />}>
                <Route path="/home" exact element={<Main />} />
            </Route>
            <Route path="/notFound" element={<NotFound />} />
            <Route default element={<NotFound />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};

export default App;
